import { PlanningGroupsResponse, PlanningGroupsResponseItem } from '@/types/service-response'
import store from '@/store'

export class PlanningGroupsSettings {
  private constructor (
    readonly id: number,
    readonly planningGroupId: number,
    readonly planningGroupName: string,
    readonly departmentId: number,
    readonly departmentName: string,
    readonly color: string | null,
    readonly language: number
  ) {}

  public static createListFromResponse (data: PlanningGroupsResponse): Array<PlanningGroupsSettings> {
    const list: PlanningGroupsResponse = data.filter((item: PlanningGroupsResponseItem) => item.Sprache === store.state.selectedUiLanguage!.syzId)

    return list.map((item: PlanningGroupsResponseItem) => {
      return new PlanningGroupsSettings(
        item.ID,
        item.PlanungsgruppeID,
        item.PlanungsgruppeName,
        item.AbteilungenID,
        item.AbteilungenName,
        item.Color,
        item.Sprache
      )
    })
  }
}
